// tokens.json is the single source — require()-able by the CJS preset/generate
// script and import-able by Vite/Vitest/TS (default import + explicit types).
import tokensJson from "./tokens.json";

type FontSize = [
  string,
  { lineHeight: string; fontWeight: string; letterSpacing?: string },
];

const tokens = tokensJson as unknown as {
  color: Record<string, string>;
  typography: Record<string, FontSize>;
  radius: Record<"sm" | "md" | "lg" | "xl" | "full", string>;
  spacing: Record<string, string>;
  elevation: Record<"flat" | "card" | "overlay" | "modal", string>;
  motion: {
    duration: Record<"fast" | "base" | "slow" | "settle", string>;
    easing: Record<"standard" | "emphasized" | "exit" | "settle", string>;
    spring: Record<
      "gentle" | "default" | "snappy",
      { type: "spring"; stiffness: number; damping: number; mass: number }
    >;
  };
  legacy: Record<string, string>;
};

export const color = tokens.color;
export const typography = tokens.typography;
export const radius = tokens.radius;
export const spacing = tokens.spacing;
export const elevation = tokens.elevation;
export const motion = tokens.motion;
export const legacy = tokens.legacy;
